( function () {
	'use strict';

	// Must configure via the routehelperConfigProvider
	function rhConfig () {
		this.config = {
			/**
			 * These are the properties we need to set
			 * $routeProvider: undefined
			 * docTitle: ''
			 * resolveAlways: {ready: function(){ } }
			 */
		};

		this.$get = function () {
			return {
				'config' : this.config
			};
		};
	}

	/* eslint-disable max-params */
	function routehelper ( $location, $rootScope, $route, logger, routehelperConfig, authService, Session, _, $window, $ ) {
		var handlingRouteChangeError = false;

		var routeCounts = {
			'errors'  : 0,
			'changes' : 0
		};

		var routes            = [];
		var $routeProvider    = routehelperConfig.config.$routeProvider;

		function configureRoutes ( routeList ) {
			routeList.forEach( function ( route ) {
				route.config.resolve = angular.extend( route.config.resolve || {}, routehelperConfig.config.resolveAlways );

				$routeProvider
					.when( route.url, route.config );
			} );

			$routeProvider.otherwise( {
				'redirectTo' : '/login'
			} );
		}

		function handleRoutingErrors () {
			// Route cancellation:
			// On routing error, go to the dashboard.
			// Provide an exit clause if it tries to do it twice.
			$rootScope.$on( '$routeChangeError', function ( event, current, previous, rejection ) {
				if ( handlingRouteChangeError ) {
					return;
				}

				routeCounts.errors++;
				handlingRouteChangeError = true;

				var destination = ( current && ( current.title || current.name || current.loadedTemplateUrl ) ) || 'unknown target';
				var msg         = 'Error routing to ' + destination + '. ' + ( rejection.msg || '' );

				logger.warning( msg, [ current ] );
				$location.path( '/' );
			} );
		}

		function getRoutes () {
			for ( var prop in $route.routes ) {
				if ( $route.routes.hasOwnProperty( prop ) ) {
					var route   = $route.routes[ prop ];
					var isRoute = Boolean( route.title );

					if ( isRoute ) {
						routes.push( route );
					}
				}
			}

			return _.uniq( routes );
		}

		function updateDocTitle ( event, current ) {
			routeCounts.changes++;

			handlingRouteChangeError = false;
			$rootScope.title         = routehelperConfig.config.docTitle + ' : ' + ( current.title || '' );
		}

		function checkAuth () {
			// Broadcasted before a route change
			$rootScope.$on( '$routeChangeStart', function ( ev, nextRoute, prevRoute ) {
				// store previous route
				if ( prevRoute ) {
					$rootScope.prevRoute = prevRoute;
				}

				// nullify obsGroupData attached on sidebar
				if ( $rootScope.obsGroupsData && !authService.isViewOnlyMode() ) {
					$rootScope.obsGroupsData = null;
				}

				// if view mode url is present in the session
				if ( authService.isViewOnlyMode() ) {
					// if token detected in url without the viewmode params
					if ( $location.search().token && !$location.search().viewmode ) {
						authService.killSession( true );
						$location.url( $location.url() ).replace();
					} else if ( !( nextRoute.params.id && nextRoute.params.token && nextRoute.params.viewmode ) ) {
						$location.url( Session.getCredentials().requestedUrl ).replace();
					}
				}

				// if token in url is present and current logged in obs,
				// kill session to replace new session which has been set in edivate
				if ( authService.isLogged() && $location.search().token ) {
					authService.killSession( true );
					$location.url( $location.url() ).replace();
				}

				// if access denied
				if ( ( nextRoute.access && nextRoute.access.requiredLogin ) && !authService.isLogged() ) {
					var searchObject = $location.search();

					// if there is a token query parameter
					if ( searchObject.token ) {
						var urlParams = $.param( searchObject );

						// switch to 'redirect view' to process the credentials
						$location.url( '/authenticate?url=' + $location.path() + '&' + urlParams ).replace();
					} else {
						// switch to login
						$location.url( '/login' );
					}
				}
			} );

			// Broadcasted after route dependencies are resolved ( ngview listens )
			$rootScope.$on( '$routeChangeSuccess', function ( ev, current ) {
				// update document title
				updateDocTitle( ev, current );

				$rootScope.isLogged = authService.isLogged();

				// if already logged and try to navigate the login page and forgot password page
				/* eslint-disable no-empty */
				try {
					if ( authService.isLogged() && !current.access.requiredLogin ) {
						$location.url( '/' );
					}
				} catch ( err ) {
					// ignore console error for route without access
				}
				/* eslint-enable no-empty */
			} );
		}

		function init () {
			handleRoutingErrors();
			checkAuth();
		}

		var service = {
			'configureRoutes' : configureRoutes,
			'getRoutes'       : getRoutes,
			'routeCounts'     : routeCounts
		};

		init();

		return service;
	}

	angular
		.module( 'blocks.router' )
		.provider( 'routehelperConfig', rhConfig )
		.factory( 'routehelper', routehelper );
	routehelper.$inject = [ '$location', '$rootScope', '$route', 'logger', 'routehelperConfig', 'authService', 'Session', '_', '$window', '$' ];
} )( );
